import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from "../../functions/api";
import { Typography, Table, TableBody, TableCell, TableHead, TableRow, Button, Box, Grid, TextField } from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useMessage } from "../../context/message-context";
import openFile from "../shared/functions/download";
import { FullPageSpinner } from "../lib";
import MandatoryDocForm from "../MandatoryDocConfirmComponent/MandatoryDocForm";
import { useTranslation } from "react-i18next";
function MandatoryDocDetails(props) {
  const { t } = useTranslation();
  let { pflichtdok } = useParams();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState(null);
  const { accessToken, client } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [gesperrt, setGesperrt] = useState("1");
  const [modus, setModus] = useState("TEXT");
  const [formular, setFormular] = useState("");
  const { hideMessage, showErrorMessage } = useMessage();
  const closeModal = () => {
    setShowModal(false);
  };
  const open = () => {
    setShowModal(true);
    downloadFile();
  };
  const ladeDocuments = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "DETAILS",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, documentCb);
  };
  //  useEffect(() => {
  //    open();
  // eslint-disable-next-line
  //  }, [])

  useEffect(() => {
    ladeDocuments();
    // eslint-disable-next-line
  }, []);
  const downloadFile = () => {
    console.log("file with key: ", pflichtdok);
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "DATEI_LADEN",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, { headers: headers, responseType: "blob" })
      .then((response) => {
        var contentFile = response.data;
        const mimeType = response.headers["Content-Type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });
  };
  const documentCb = (response) => {
    if (response.status === 200) {
      if (response.data.document) {
        setDocuments(response.data.document);
        setFileName(response.data.filename);
        setModus(response.data.fragenModus);
        if (response.data.fragenModus==="FORMULAR"){
          console.log(response.data.document.find((e)=>e.frage!==undefined))
          console.log(response.data.document.find((e)=>e.frage!==undefined).frage)
          console.log(Object.keys(response.data.document.find((e)=>e.frage!==undefined).frage)[0])
          setFormular(Object.keys(response.data.document.find((e)=>e.frage!==undefined).frage)[0])
        }
        setGesperrt(response.data.gesperrt);
      } else {
        setDocuments([]);
        setFileName("");
        setGesperrt("1");
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  if (isLoading) {
    return <LoadingComponent />;
  }

  if (!documents) {
    return (
      <Typography color="primary" variant="h5">
        {t("Pflichtdokument konnte nicht gefunden werden")}
      </Typography>
    );
  }
  const dataRequest =
    documents.length > 0 ? (
      documents.map((element) => {
        return (
          <Fragment>
            {!element.frage && (
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  label={element.bez}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  disabled
                  multiline
                  value={element.antwort}
                ></TextField>
              </Grid>
            )}
            {element.frage && (
              <>
                {modus === "TEXT" ? (
                  <Grid item xs={12}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>{t("Frage")}</TableCell>
                          <TableCell>{t("Antwort")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {element.frage.map((antwort) => {
                          return (
                            <TableRow>
                              <TableCell>{antwort.bez} </TableCell>
                              <TableCell>{antwort.antwort} </TableCell>
                            </TableRow>
                          );
                        })}
                        {gesperrt === "0" && (
                          <TableRow>
                            <TableCell colSpan={2}>
                              <Button variant="contained" color="primary" fullWidth onClick={() => navigate("/WEBPDB/pflichtdoc/confirm/" + pflichtdok)}>
                                {t("Antworten bearbeiten")}
                              </Button>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Grid>
                ) : (<>

                   <MandatoryDocForm
                   formular={formular}
                   liste={element.frage[formular][formular]?.inhalt.split(";")}
                   felder={element.frage}
                   accessToken={accessToken} client={client}
                   pflichtdok={pflichtdok}
                   disabled={true}/>
                </>
                
                )}
              </>
            )}
          </Fragment>
        );
      })
    ) : (
      <TableRow>
        <Typography variant="body1">{t("Es wurden keine offenen Pflichtdokumente gefunden")}</Typography>
      </TableRow>
    );
  return (
    <div className="pt-2 h-100 container-fluid mb-4">
      <Box p={2}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} lg={8}>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
              <Grid item xs={12}>
                <Button onClick={open} variant="contained" color="primary" fullWidth>
                  {t("Dokument erneut öffnen")}
                </Button>
              </Grid>
              {dataRequest}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {showModal && <FullPageSpinner />}
    </div>
  );
}
export default MandatoryDocDetails;
